(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const popup = document.querySelector('newsletter-popup');
    if (urlParams.get('newsletter_popup') === '1') {
        if (popup) {
            popup.show();
            cleanUrl();
        }
    }

    function cleanUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('newsletter_popup');
        window.history.replaceState({}, '', url);
    }
})();

 